import * as React from 'react'
import PropTypes from 'prop-types'
import { Image, makeStyles } from '@fluentui/react-components'
import style from '../styles/header'

const useStyles = makeStyles(style)

const Header = (props) => {
  const { title, logo } = props

  const classes = useStyles()

  return (
    <div>
      <section className={classes.welcome__header}>
        <Image width='90' height='90' src={logo} alt={title} />
      </section>
    </div>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  logo: PropTypes.string,
  message: PropTypes.string
}

export default Header
